import Vue from "vue";
import Vuex from "vuex";
import ArchiveImageStore from "@Scripts/Stores/ArchiveImageStore";

Vue.use(Vuex);

export const store = new Vuex.Store({});

store.registerModule("archiveImageStore", ArchiveImageStore);